// src/pages/SupplierList.jsx

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../axios';
import API_BASE_URL from '../../config';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default function SupplierList() {
  const navigate  = useNavigate();
  const companyId = localStorage.getItem('companyId');
  const [suppliers, setSuppliers] = useState([]);

  useEffect(() => {
    if (!companyId) return;
    axios.get(`/Supplier/by-company/${companyId}`)
      .then(res => setSuppliers(res.data))
      .catch(err => console.error('❌ Error loading suppliers:', err));
  }, [companyId]);

  const deleteSupplier = id => {
    if (!window.confirm('❗ تأكيد الحذف')) return;
    axios.delete(`${API_BASE_URL}/Supplier/${id}`)
      .then(() => {
        setSuppliers(ss => ss.filter(s => s.id !== id));
        alert('🗑️ تم حذف المورد');
      })
      .catch(err => {
        console.error('❌ Error deleting supplier:', err);
        alert('❌ حدث خطأ أثناء الحذف');
      });
  };

  const exportToExcel = () => {
    const data = suppliers.map((s, idx) => ({
      'رقم': idx + 1,
      'الاسم': s.name,
      'الرقم الضريبي': s.taxNumber || '-',
      'الجوال': s.mobile || '-'
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'الموردين');
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 
           `suppliers_${new Date().toISOString().slice(0,10)}.xlsx`);
  };

  return (
    <Card className="p-6" dir="rtl">
      <CardContent>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">📋 قائمة الموردين</h2>
          <div className="flex gap-2">
            <Button onClick={exportToExcel}>📥 تصدير Excel</Button>
            <Button onClick={() => navigate('/Supplier/new')}>➕ إضافة مورد</Button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full table-auto border-collapse text-sm">
            <thead>
              <tr className="bg-gray-100">
                {['#','الاسم','الرقم الضريبي','الجوال','إجراءات'].map((h,i) => (
                  <th key={i} className="px-4 py-2 border text-center">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {suppliers.map((s, idx) => (
                <tr key={s.id} className={idx%2===0?'bg-white':'bg-gray-50'}>
                  <td className="px-4 py-2 border text-center">{idx + 1}</td>
                  <td className="px-4 py-2 border">{s.name}</td>
                  <td className="px-4 py-2 border text-center">{s.taxNumber || '-'}</td>
                  <td className="px-4 py-2 border text-center">{s.mobile || '-'}</td>
                  <td className="px-4 py-2 border text-center space-x-2">
                    <Button size="sm" variant="outline"
                      onClick={() => navigate(`/Supplier/${s.id}/edit`)}>
                      ✏️
                    </Button>
                    <Button size="sm" variant="destructive"
                      onClick={() => deleteSupplier(s.id)}>
                      🗑️
                    </Button>
                  </td>
                </tr>
              ))}
              {suppliers.length === 0 && (
                <tr>
                  <td colSpan={5} className="px-4 py-6 border text-center text-gray-500">
                    لا يوجد موردين
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
